import { useParams } from 'react-router';

import Game from '../components/game';

export default function Room( ) {
	const { roomId } = useParams();
	return (
		<Game room={ roomId } />
	);
}